const opts = {
  filterable: false,
  sortable: false
};
export default {
  id: 'sale.tagIds',
  name: 'sale.tagIds',
  displayName: 'Sold Tag IDs',
  valueType: 'string',
  objectType: 'sale',
  blueprint: {},
  getOption: key => {
    return opts[key];
  },
  get: obj => {
    return obj?.data?.keys ? Object.values(obj.data.keys).reduce((prev, key) => {
      if (key.tagSerialNumber) {
        prev.push(key.tagSerialNumber);
      }
      return prev;
    }, []) : null;
  }
};